import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", { class: "text-muted" }, " Chức năng này tạm thời chưa khả dụng, vui lòng quay lại sau ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ButtonCustom = _resolveComponent("ButtonCustom")!
  const _component_PageRowLayout = _resolveComponent("PageRowLayout")!

  return (_openBlock(), _createBlock(_component_PageRowLayout, null, {
    "page-row-header": _withCtx(() => [
      _createTextVNode(_toDisplayString(_ctx.isCreating ? 'Tạo mới' : 'Cập nhật'), 1)
    ]),
    "page-row-action-button": _withCtx(() => [
      _createVNode(_component_ButtonCustom, {
        "button-type": "BACK",
        onClick: _ctx.goBack
      }, null, 8, ["onClick"])
    ]),
    "page-row-content": _withCtx(() => [
      _hoisted_1
    ]),
    _: 1
  }))
}